import Vue from 'vue'
import loading from 'vuejs-loading-screen'

const params = (new URLSearchParams(window.location.search))
const parameterBackgroundColor = params.get('background')
const parameterLoadingColor = params.get('loading_color')
const iconColor = parameterLoadingColor ? '#' + parameterLoadingColor : '#fff'

Vue.use(loading, {
    bg: parameterBackgroundColor ? '#' + parameterBackgroundColor : 'rgb(0 0 0 / 0.5)',
    size: 5,
    slot: '<i class="fas fa-globe fa-pulse fa-3x fa-fw" style="color:' + iconColor + '"></i>',
})